import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

import { createNotification } from '../../notifications/store/actions'

type QueryOptions = {
  unsubscribe?: boolean
}

export const useGetGroupLazy = ({ unsubscribe = false }: QueryOptions = {}) => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [getGroup, res] = esApi.endpoints.getOrgGroup.useLazyQuery()

  const getGroupLazy = useCallback(
    async (groupId: number) => {
      if (!orgId || !groupId) {
        return
      }

      try {
        const req = getGroup({ orgId: orgId.toString(), groupId: groupId.toString() })
        const data = await req.unwrap()
        if (unsubscribe) {
          // Unsubscribe from the cache change
          req.unsubscribe()
        }
        return data
      } catch (error) {
        dispatch(
          createNotification({
            'get-group-failure': {
              type: 'error',
              message: getErrorMessage(error, 'Failed to get contact group'),
            },
          }),
        )
        return
      }
    },
    [orgId, unsubscribe, dispatch, getGroup],
  )

  return [getGroupLazy, res] as const
}
